import React, { useEffect, useState } from 'react';
import Card from 'components/Layout/Card';

import './AttendancesList.scss';
import ClientAttendancesList from './ClientAttendancesList';
import CommitteeMemberList from './CommitteeMemberList';
import CoAuthorAttendancesList from './CoAuthorAttendancesList';

const AttendancesList = () => {
  const [tabType, setTabType] = useState('author');

  const tabOptions = [
    { label: 'Author', value: 'author' },
    { label: 'Co-Author', value: 'co-author' },
    { label: 'Listener', value: 'listener' },
    { label: 'Committee Member', value: 'committee-member' },
  ];

  return (
    <Card className="cps-20 cpe-20 cpb-20 mt-3">
      <div className="attendances-tab">
        {tabOptions.map((tab) => (
          <div
            key={tab.value}
            className={`btn ${tabType === tab.value ? 'active' : ''}`}
            onClick={() => setTabType(tab.value)}
          >
            {tab.label}
          </div>
        ))}
      </div>

      {tabType === 'author' && <ClientAttendancesList type="presenter"/>}
      {tabType === 'co-author' && <CoAuthorAttendancesList />}
      {tabType === 'listener' && <ClientAttendancesList type="listener" />}
      {tabType === 'committee-member' && <CommitteeMemberList />}
    </Card>
  );
};

export default AttendancesList;
